import { batch } from 'react-redux';
import { toDictionary, toList } from '@ff-os/shared-utils/dictionaries';
import { unwrap } from '@ff-os/shared-utils/unwrap';
import { createUserInputsPatch } from '@ff-resource-plugins/prefabs-shared/merge-logic/createUserInputsPatch';
import { actions as inputActions } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { actions as metaActions } from '@ff-scene-plugins/gift-redux/slices/metaSlice';
import { actions as variableActions } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState, GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { matchActiveVariant } from '@ff-scene-plugins/gift-shared/matchActiveVariant';
import { filterPrefabs } from '../_redux-prefabs';

export const preprocess = (store: GiftPdpStore) => {

    const { inputs, variables, meta } = mergeDefaultPrefab(store.getState());

    batch(() => {

        if (inputs) {
            store.dispatch(inputActions.upsertMany(toList(inputs)));
        }

        if (variables) {
            store.dispatch(variableActions.setAll(toList(variables)));
        }

        if (meta) {
            store.dispatch(metaActions.overwrite(meta));
        }
    });
};

const mergeDefaultPrefab = ({ project, resources, tenant, scene }: GiftPdpState) => {

    const { inputs, meta, variables } = project;
    const variants = scene.options.variants;

    const activeVariantId = matchActiveVariant(unwrap(variants), inputs.entities).id;
    const defaultPrefab = filterPrefabs(resources.prefab!, tenant.id, activeVariantId)[0];

    if (!defaultPrefab) {
        return {
            meta: meta,
            variables: variables.entities,
            inputs: inputs.entities
        };
    }

    const patchedInputs = createUserInputsPatch(inputs, defaultPrefab);
    const pinnedVariables = unwrap(variables).filter(v => v.pinned);

    return {

        meta: {
            public: {
                prefabId: defaultPrefab.id,
                commission: defaultPrefab.commission
            },

            activeVariantId: activeVariantId,
            viewboxWidth: defaultPrefab.viewbox.width,
            viewboxHeight: defaultPrefab.viewbox.height
        },

        variables: {
            ...toDictionary(pinnedVariables, v => v.id),
            ...defaultPrefab.variables.entities
        },

        inputs: {
            ...inputs.entities,
            ...patchedInputs
        }
    };
};